import { WalletState } from '@app/wallet/store/wallet.reducer';
import { createSelector } from '@ngrx/store';

export function getCreditState(state): WalletState {
  return state.credit;
}

export const getTopUpAmount = createSelector(
  getCreditState,
  (state) => state.amount
);

export const getTopUpPaymentMethod = createSelector(
  getCreditState,
  (state) => state.paymentMethod
);

export const getPendingBalanceAmount = createSelector(
  getCreditState,
  (state) => state.pendingBalance
);

export const getPayoutAmount = createSelector(
  getCreditState,
  (state) => state.payoutAmount
);

export const getPayoutType = createSelector(
  getCreditState,
  (state) => state.payoutType
);

export const getCryptoInfo = createSelector(
  getCreditState,
  (state) => state.cryptoInfo
);

export const getCryptoPayment = createSelector(
  getCreditState,
  (state) => state.cryptoPayment
);

export const getCryptoPaymentResponse = createSelector(
  getCreditState,
  (state) => state.cryptoPaymentResponse
);
